@if (data(); as data) {
  <pfx-panel
    [toggleable]="!!data.details"
    [(collapsed)]="collapsed"
    [severity]="data.severity"
  >
    @if (getPanelTemplate(PanelTemplateType.ICONS); as iconsTemplate) {
      <ng-template [pfxTemplate]="PanelTemplateType.ICONS">
        <ng-container *ngTemplateOutlet="iconsTemplate; context: { $implicit: data.meta }"></ng-container>
      </ng-template>
    }

    <ng-template [pfxTemplate]="PanelTemplateType.HEADER">
      <div
        class="flex flex-col items-start gap-2"
        (click)="handleOnPanelClicked(data)"
      >
        <div
          class="flex flex-row items-center"
          [class.gap-3]="[data.title].flat().length > 1"
        >
          @for (item of [data.title].flat(); track item) {
            @if (item) {
              <div
                class="flex flex-row items-center gap-2"
                (click)="item.command ? item.command(data) : null"
              >
                @if (item.icon) {
                  <pfx-icon
                    [icon]="item.icon"
                    [ngStyle]="{ color: item.iconColor }"
                    size="lg"
                  ></pfx-icon>
                }
                <strong class="text-xl">{{ item.text }}</strong>
              </div>
            }
          }
        </div>

        @if (data.subtitle) {
          <div
            class="flex flex-row"
            [class.gap-3]="[data.subtitle].flat().length > 1"
          >
            @for (item of [data.subtitle].flat(); track item) {
              <div
                class="flex flex-row items-center gap-2"
                (click)="item.command ? item.command(data) : null"
              >
                @if (item.icon) {
                  <pfx-icon
                    [icon]="item.icon"
                    [ngStyle]="{ color: item.iconColor }"
                  ></pfx-icon>
                }
                <span>{{ item.text }}</span>
              </div>
            }
          </div>
        }

        @if (data.description) {
          <div
            class="flex flex-row"
            [class.gap-3]="[data.description].flat().length > 1"
          >
            @for (item of [data.description].flat(); track item) {
              <div
                class="flex flex-row items-center gap-2"
                (click)="item.command ? item.command(data) : null"
              >
                @if (item.icon) {
                  <pfx-icon
                    [icon]="item.icon"
                    [ngStyle]="{ color: item.iconColor }"
                    size="sm"
                  ></pfx-icon>
                }
                <small>{{ item.text }}</small>
              </div>
            }
          </div>
        }
      </div>
    </ng-template>

    <ng-template [pfxTemplate]="PanelTemplateType.CONTENT">
      <div class="py-1">
        @if (getPanelTemplate(PanelTemplateType.CONTENT); as contentTemplate) {
          <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: data.details }"></ng-container>
        } @else {
          {{ data.details | json }}
        }
      </div>
    </ng-template>
  </pfx-panel>
}
